import React from 'react';
import Container from '../../components/Container/Container';
import SliderComponent from '../../components/SliderComponent/SliderComponent';
import NewItems from '../../components/NewItems/NewItems';
import SearchNewProducts from '../../components/SearchNewProducts/SearchNewProducts';
import Hero from '../../components/Hero/Hero';
import Ribbon from '../../components/Ribbon/Ribbon';

export default function Main() {
  return (
    <div>
      <Hero
        title={'Геймерські аксесуари  \n з топовим  \n функціоналом!'}
        sendUrl={'/Images/hero/hero.png'}
      />
      <Ribbon />
      <Container>
        <SliderComponent />
      </Container>
      <Ribbon />
      <NewItems />

      <SearchNewProducts />
    </div>
  );
}
